import { hasRoleAccess } from '@/auth/utils'
import ability from './ability'

/**
 * Check if user can navigate to target route based on CASL ability and route meta.allowedRoles.
 * @param {Route} to - Target route object
 * @returns {boolean}
 */
export const canNavigate = to => (
  to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource))
  && to.matched.every(route => hasRoleAccess(route.meta.allowedRoles))
)

export const _ = undefined
